export interface CheckoutReceiptFooterConfig {
  version: 1
  enabled: boolean
}

export interface CheckoutReceiptFooterShopInfo {
  contactPhone?: null | string
  shopAddress?: null | string
}

export interface CheckoutReceiptFooterContext {
  config?: null | Partial<CheckoutReceiptFooterConfig>
  shopInfo?: CheckoutReceiptFooterShopInfo | null
}

export const DEFAULT_CHECKOUT_RECEIPT_FOOTER_CONFIG: CheckoutReceiptFooterConfig = {
  version: 1,
  enabled: false,
}

export function resolveCheckoutReceiptFooterConfig(
  config?: null | Partial<CheckoutReceiptFooterConfig>,
): CheckoutReceiptFooterConfig {
  return {
    version: 1,
    enabled: config?.enabled === true,
  }
}

export function buildCheckoutReceiptFooterPreviewLines(shopInfo?: CheckoutReceiptFooterShopInfo | null) {
  const lines: string[] = []
  const contactPhone = shopInfo?.contactPhone?.trim()
  const shopAddress = shopInfo?.shopAddress?.trim()
  if (contactPhone) {
    lines.push(`联系电话：${contactPhone}`)
  }
  if (shopAddress) {
    lines.push(`店铺地址：${shopAddress}`)
  }
  return lines
}

export function hasCheckoutReceiptFooterContent(shopInfo?: CheckoutReceiptFooterShopInfo | null) {
  return buildCheckoutReceiptFooterPreviewLines(shopInfo).length > 0
}

export function buildCheckoutReceiptFooterLines(
  config: null | Partial<CheckoutReceiptFooterConfig> | undefined,
  shopInfo?: CheckoutReceiptFooterShopInfo | null,
) {
  return resolveCheckoutReceiptFooterConfig(config).enabled
    ? buildCheckoutReceiptFooterPreviewLines(shopInfo)
    : []
}
